import { Injectable } from '@angular/core';

import * as moment from 'moment';

@Injectable()
export class DateUtils {

    todayUrl() {
        return ["/date", "today"];
    }

    dayUrl(date : Date) {
        if (date === null || date === undefined || this.isToday(date)) {
            return this.todayUrl();
        }
        let dateStr = this.formatDate(date);
        return ["/date", dateStr];
    }

    /** Formats date compatible with firebase item paths. */
    formatDate(date : Date) : string {
        return date.getFullYear() + "-" + this.twoDigits(date.getMonth()+1) + "-" + this.twoDigits(date.getDate());
    }

    formatDateDisplay(date : Date) : string {
        if (this.isToday(date)) {
            return "Today";
        } else {
            let dateStr = this.dayName(date) + ", " + date.getDate() + " " + this.shortMonthName(date);
            if (date.getFullYear() == new Date().getFullYear()) {
                return dateStr;
            } else {
                return dateStr + " " + date.getFullYear();
            }
        }
    }

    twoDigits(number : number) : string {
        let nrStr = number.toString();
        if (nrStr.length == 1) {
            return "0" + nrStr;
        } else {
            return nrStr;
        }
    }

    dayName(date : Date) : string {
        let dayNo = date.getDay();
        let days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        return days[dayNo];
    }

    shortMonthName(date : Date) : string {
        let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
        return months[date.getMonth()];
    }

    isToday(date : Date) : boolean {
        return this.isSameDate(date, new Date());
    }

    isSameDate(a : Date, b : Date) : boolean {
        return a.getDate() == b.getDate() &&
            a.getMonth() == b.getMonth() &&
            a.getFullYear() == b.getFullYear();
    }

    weekUrl(date : Date) {
        if (date === null || date === undefined) {
            return ["/week"];
        }
        let m = moment(date);
        let week = m.isoWeek();
        let year = m.isoWeekYear();
        let thisWeek = moment().isoWeek();
        let thisYear = moment().isoWeekYear();
        if (year == thisYear) {
            if (week == thisWeek) {
                return ["/week"];
            }
            return ["/week", week.toString()];
        }
        return ["/week", week.toString(), {year: year.toString()}];
    }

    /** Checks whether the two dates are in the same week. */
    isSameWeek(a : Date, b : Date) {
        let am = moment(a);
        let bm = moment(b);
        return am.isoWeekYear() == bm.isoWeekYear() && am.isoWeek() == bm.isoWeek();
    }

    /** Checks whether the given that is within the current week */
    isThisWeek(date : Date) {
        return this.isSameWeek(date, new Date());
    }

    /**
     * Returns a copy of the date that points to the Monday of that week.
     * Shifts the times at midnight local time.
     */
    beginningOfWeek(date : Date) : Date {
        return moment(date).startOf("isoWeek").toDate();
    }

}



// WEBPACK FOOTER //
// /Users/vlad/Projects/done/web/src/app/dateutils.service.ts